import DeleteFilterDrawer from './delete-filter-drawer';

export default DeleteFilterDrawer;
